<template>
  <div class="section_container">
    <div>
      <div class="section_description" :style="getTopColor()">
        <div>
          <slot name="title"></slot>
          <slot name="description"></slot>
        </div>
      </div>
      <div class="section_action_container" :style="getBottomColor()">
        <div class="section_action">
          <slot name="action"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function(){
    return {
      name: 'Module'
    }
  },
  props: ['topColor', 'bottomColor', 'bottomText'],
  methods: {
    getTopColor: function(){
      return{
        'background-color': this.topColor
      };
    },
    getBottomColor: function(){
      return{
        'background-color': this.bottomColor
      };
    }
  }
}
</script>